import React, { useEffect, useState } from "react";
import styles from "../Pages.module.css";
import tableStyles from "../../components/Table/Table.module.css";
import { baseURL } from "../../components/utils/utils";
import { useFetch } from "../../hooks/useFetch";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { editIcon } from "../../components/utils/iconsPath";

const Apontamentos = () => {
  const navigate = useNavigate();
  const { httpGet, loading } = useFetch(`${baseURL}/apontamentos/`);
  const { httpGet: httpUsers } = useFetch(`${baseURL}/usuarios/`);
  const { error, httpGet: httpItens } = useFetch(`${baseURL}/itens/`);

  const { user } = useAuthContext();

  const [usersList, setUsersList] = useState([]);
  // const [itensList, setItensList] = useState([]);

  const [dadosTabela, setTabela] = useState([]);
  const [data, setData] = useState([]);

  //dados do formulário
  // const [apontamento, setApontamento] = useState([]);

  // Effects de retorno dos dados:
  useEffect(() => {
    //console.log("Apontamentos");
    const getList = async () => {
      if (user && user.token) {
        const usuarios = await httpUsers(user.token, "listar");
        setUsersList(usuarios); // Armazena os usuarios
        const itens = await httpItens(user.token, "listar");
        // setItensList(itens); // Armazena os Itens de projeto
        itens && setTabela(itens);
        const dados = await httpGet(user.token, "listar");
        if (dados && dados) {
          setData(dados);
        }
      } else {
        navigate("/login");
      }
    };
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log(user);
    if (!user) {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const retPercentual = (item) => {
    const percentual = (retTotalApontado(item) / item.ItemHoras) * 100;
    return `${percentual.toFixed(2)} %`;
  };

  const retStatus = (item) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const prazo = new Date(item.ItemPrazo);
    const percent = retTotalApontado(item);
    if (percent === 100) {
      return "Concluído";
    } else if (hoje <= prazo && percent === 0) {
      return "Pendente"; // Se a data do item for hoje ou anterior, está "Em dia"
    } else if (hoje <= prazo && percent < 100 && percent > 0) {
      return "Em andamento";
    } else if (hoje > prazo && percent < 100) {
      return "Atrasado";
    }
    return;
  };

  const retUserName = (item) => {
    const consultor = usersList.find(
      (cons) => cons.UsuId === Number(item.fk_UsuId)
    );
    return consultor.UsuNome;
  };

  const retTotalApontado = (item) => {
    let horas = 0;
    if (data) {
      data.forEach((dado) => {
        if (item && item.ItemId === dado.fk_ItemId) horas += dado.ApoQtdHoras;
      });
    }
    return horas;
  };

  function decimalToHours(decimal) {
    const hours = Math.floor(decimal); // Parte inteira: horas
    const minutes = Math.round((decimal - hours) * 60); // Parte decimal convertida em minutos
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`; // Formatar como hh:mm
  }

  const onClickPointment = (item) => {
    //  console.log(item);
    navigate(`/registrar/${item.ItemId}`);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Apontamentos</h1>
      <div className={styles.card}>
        {loading && <p className={styles.loading}>Carregando...</p>}
        {error && <p className={styles.error}>{error}</p>}

        <table className={tableStyles.table}>
          <thead>
            <tr className={tableStyles.tr}>
              <th className={tableStyles.th}>Consultor</th>
              <th className={tableStyles.th}>Tarefa</th>
              <th className={tableStyles.th}>Prazo</th>
              <th className={tableStyles.th}>Horas Prev</th>
              <th className={tableStyles.th}>Apontado</th>
              <th className={tableStyles.th}>Concluido</th>
              <th className={tableStyles.th}>Status</th>
              <th className={tableStyles.th}>Apontar</th>
            </tr>
          </thead>
          <tbody>
            {dadosTabela &&
              dadosTabela.map((row) => {
                return (
                  <tr className={tableStyles.tr} key={row.ItemId}>
                    <td className={tableStyles.td}>{retUserName(row)}</td>
                    <td className={tableStyles.td}>{row.ItemDes}</td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {row.ItemPrazo}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {row.ItemHoras}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {decimalToHours(retTotalApontado(row))}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.right}`}>
                      {retPercentual(row)}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {retStatus(row)}
                    </td>
                    <td className={tableStyles.tdIcon}>
                      <img
                        className={tableStyles.icon}
                        src={editIcon}
                        alt="Registrar horas"
                        title="Registrar horas"
                        onClick={() => onClickPointment(row)}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Apontamentos;
